@let key = offer()?.offerKey;
@if (
  key === HubOfferKey.HUB_ITA_REFINANCE_SINGLE_LOAN ||
  key === HubOfferKey.HUB_REFINANCE_UNSECURED_PERSONAL_LOAN
) {
  <img
    ngSrc="assets/icons/money-bag-circle.svg"
    width="64"
    height="64"
    alt=""
  />
} @else if (
  key === HubOfferKey.HUB_HSL_PASSIVE_REFINANCE_SINGLE_LOAN ||
  key === HubOfferKey.HUB_UPL_PASSIVE_REFINANCE_SINGLE_LOAN
) {
  <img
    ngSrc="assets/icons/lightbulb-gradient.svg"
    width="64"
    height="64"
    alt=""
  />
} @else if (
  key === HubOfferKey.HUB_UPL_CASHOUT_REFINANCE_SINGLE_LOAN ||
  key === HubOfferKey.HUB_HSL_CASHOUT_REFINANCE_SINGLE_LOAN
) {
  <img
    ngSrc="assets/icons/cash-gradient.svg"
    width="64"
    height="64"
    alt=""
  />
} @else if (key === HubOfferKey.HUB_ITA_REFINANCE_MULTI_LOAN) {
  <img ngSrc="assets/icons/money-coin.svg" width="64" height="64" alt="" />
} @else if (key === HubOfferKey.RESUMABLE_APP) {
  <img
    ngSrc="assets/icons/notepad-pen-carousel.png"
    width="103"
    height="72"
    alt=""
  />
} @else if (key === HubOfferKey.HUB_PASSIVE_AND_SECOND_HSL) {
  <img
    ngSrc="assets/icons/lower-percent-gradient.svg"
    width="64"
    height="64"
    alt=""
  />
} @else if (key === HubOfferKey.HUB_PASSIVE_AND_SECOND_OPTIN) {
  <div
    class="flex items-center justify-center bg-linear-to-b/srgb from-[#8BDB67] to-[#277A1B] bg-clip-text text-transparent"
  >
    <p class="m-0 flex flex-nowrap items-center justify-center">
      <span class="heading-m-bold shrink-0">$</span>
      <span class="flex items-baseline">
        <span class="heading-xl-bold">{{ maxAmountThousands() }}</span>
        <span class="heading-m-bold">k</span>
      </span>
    </p>
  </div>
} @else if (
  key === HubOfferKey.HUB_UPL_PASSIVE_REFINANCE_MULTI_LOAN ||
  key === HubOfferKey.HUB_HSL_PASSIVE_REFINANCE_MULTI_LOAN
) {
  <div
    class="flex items-center justify-center bg-linear-to-b/srgb from-[#8BDB67] to-[#277A1B] bg-clip-text text-transparent"
  >
    <p class="m-0 flex flex-nowrap items-center justify-center">
      <span class="flex items-baseline">
        <span class="heading-xl-bold">{{ roundedMinApr() }}</span>
        <span class="heading-m-bold">%</span>
      </span>
    </p>
  </div>
} @else if (
  key === HubOfferKey.HUB_SECOND_LOAN_ONLY ||
  key === HubOfferKey.HUB_PASSIVE_INVALID_AND_SECOND ||
  key === HubOfferKey.HUB_PASSIVE_ERROR_AND_SECOND ||
  key === HubOfferKey.HUB_PASSIVE_AND_SECOND
) {
  <img
    ngSrc="assets/icons/badge-dollar-sign.svg"
    width="64"
    height="64"
    alt=""
  />
} @else {
  <img
    ngSrc="assets/icons/badge-dollar-sign.svg"
    width="64"
    height="64"
    alt=""
  />
}
